import React from 'react'
import ReactDom from 'react-dom'
import ListItem from './ListItem'
import R from 'ramda'

class FilterList extends React.Component {

  constructor(props) {
    super(props)

    this.getInputValue = this.getInputValue.bind(this)
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !R.equals(this.props.inputs, nextProps.inputs)
    || !R.equals(this.props.filters, nextProps.filters)
  }

  componentDidMount() {
    const {
      inputs
    } = this.props
  }

  componentDidUpdate(prevProps, previousState) {
    const {
      inputs
    } = this.props
  }

  getInputValue(input) {
    const {
      filters
    } = this.props

    let inputValue = null

    if (filters[input.valueFor] !== undefined) {
      inputValue = filters[input.valueFor]
    } else if (input.options !== undefined && input.options[0] !== undefined) {
      inputValue = input.options[0].value
      if (input.defaultOption !== undefined) {
        inputValue = input.defaultOption
      }
    }
    return inputValue
  }

  render() {
    const {
      imagePath,
      inputs,
      properties,
      property
    } = this.props

    return (
    <div className="filters-container">
        <div className="filter-tagline">
          <p>
            <span style={{fontWeight: '300'}}>{property.name + '. '}</span>
            <span>Start your search.</span>
          </p>
        </div>
        <div className="filter">
        {properties ? (
          <div className="filter-item filter-item-property">
            <select
              className="filter-select"
              onChange={event => window.location = event.target.value}>
              {properties.map((property, index) => (
                 <option
                  key={index}
                  selected={window.location.href === property.value ? 'selected' : null}
                  value={property.value}>
                  {property.label}
                </option>
               ))}
            </select>
          </div>
        ) : null }

          {inputs.map((input, key) => (
            <ListItem
              key={key}
              value={this.getInputValue(input)}
              input={input}
              onChange={this.props.onChange} />
          ))}

          <div className="filter-item filter-item-reset">
            <a onClick={this.props.onFilterReset} href="#">
              <span className="reset-icon"></span>Reset
            </a>
          </div>
        </div>
        <div className="filter-logo">
          <a href="http://sightmap.com/" target="_blank">
            <img src={ imagePath + 'sightmap-logo.svg'}/>
          </a>
        </div>
      </div>
    )
  }
}

FilterList.defaultProps = {
  inputs: []
}

export default FilterList
